/* unplugin-vue-components disabled */import script from "./message-abstract-custom.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-abstract-custom.vue?vue&type=script&setup=true&lang=ts"

import "./message-abstract-custom.vue?vue&type=style&index=0&id=43fa3a2b&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43fa3a2b"]])

export default __exports__